








































import { Component, Vue } from 'vue-property-decorator'
import VButton from '@/components/miniComponents/VButton.vue'
import { Action } from 'vuex-class'
const namespace = 'partyRoom'

@Component({
  components: {
    VButton
  }
})
export default class CreateParty extends Vue {
  @Action('createRoom', { namespace }) dispatchCreateRoom: any

  private name = ''
  private loading = false

  changeMode () {
    this.$emit('changeMode', 'join')
  }

  async createRoom () {
    if (this.name.length > 0) {
      this.loading = true
      await this.dispatchCreateRoom(this.name)
      this.$router.push('/enter')
      this.loading = false
    }
  }
}
